import { DishId } from 'app/common/types/id'
import { features } from 'app/features'

export enum DishesTableColumn {
  Check = 'check',
  Id = 'id',
  Nomenclature = 'nomenclature',
  ProcessingLevel = 'processingLevel',
  Title = 'title',
  Photo = 'photo',
  Portion = 'portion',
  Unit = 'unit',
  Cost = 'cost',
  SaleType = 'saleType',
  Options = 'options',
}

export const dishesTableColumnArrangement = [
  DishesTableColumn.Check,
  DishesTableColumn.Id,
  DishesTableColumn.Nomenclature,
  DishesTableColumn.ProcessingLevel,
  DishesTableColumn.Title,
  DishesTableColumn.Photo,
  DishesTableColumn.Portion,
  DishesTableColumn.Unit,
  DishesTableColumn.Cost,
  DishesTableColumn.SaleType,
  DishesTableColumn.Options,
]

export const useDishesTableColumnHeaders = (
  currency: string,
): Array<Record<DishesTableColumn, string>> => [
  {
    [DishesTableColumn.Check]: '',
    [DishesTableColumn.Id]: 'ID',
    [DishesTableColumn.Nomenclature]: 'Номенклатура',
    [DishesTableColumn.ProcessingLevel]: 'Состояние продукции',
    [DishesTableColumn.Title]: features.dishes.barcode
      ? 'Наименование\u00A0/ штрих\u2011код'
      : 'Наименование',
    [DishesTableColumn.Photo]: 'Фото',
    [DishesTableColumn.Portion]: 'Порция',
    [DishesTableColumn.Unit]: 'Единица измерения',
    [DishesTableColumn.Cost]: `Цена,\u00A0${currency}`,
    [DishesTableColumn.SaleType]: 'Тип\u00A0продукции',
    [DishesTableColumn.Options]: '',
  },
]

export const dishesTableColumnCellProps = {
  [DishesTableColumn.Check]: { alignLeft: true, width: 50 },
  [DishesTableColumn.Id]: { alignLeft: true },
  [DishesTableColumn.Nomenclature]: { alignLeft: true },
  [DishesTableColumn.ProcessingLevel]: { alignLeft: true, maxWidth: 150 },
  [DishesTableColumn.Title]: { alignLeft: true, maxWidth: 200 },
  [DishesTableColumn.Photo]: { alignCenter: true },
  [DishesTableColumn.Portion]: { alignLeft: true },
  [DishesTableColumn.Unit]: { alignLeft: true },
  [DishesTableColumn.Cost]: { alignLeft: true },
  [DishesTableColumn.SaleType]: { alignLeft: true, maxWidth: 220 },
  [DishesTableColumn.Options]: { alignRight: true },
}

export type TableDataItem = {
  [DishesTableColumn.Check]: string
  [DishesTableColumn.Id]: DishId
  [DishesTableColumn.Nomenclature]: string
  [DishesTableColumn.ProcessingLevel]: string
  [DishesTableColumn.Title]: string
  [DishesTableColumn.Photo]: string
  [DishesTableColumn.Portion]: string
  [DishesTableColumn.Unit]: string
  [DishesTableColumn.Cost]: string
  [DishesTableColumn.SaleType]: string
  [DishesTableColumn.Options]: string
}
